import { Injectable } from '@angular/core';
import { HttpService } from '../../../core/services/http.service';
import { environment } from '../../../../environments/environment';
import { HttpRequestHandler } from '../../../core/models/http-model';
import { AlertService } from '../../../shared/services/alert.service';
import { data } from 'jquery';

export interface HandlerPromise {
  success: (data) => void;
  error: (error) => void;
}

@Injectable()
export class GenerationJobsService {

  static ENV = environment;

  constructor(
    private _httpService: HttpService,
    private _alertService: AlertService
  ) { }


  /**
   * Se encarga de consultar la parametrizacion para los payLoads de los servicios 
   * de creacion de JOBS
   */
  private getPayLoads(data: any, httpRequesthandler: HttpRequestHandler) {
    httpRequesthandler.headers = {}
    this._httpService.post(GenerationJobsService.ENV.environment.API.services_third,
      data,
      httpRequesthandler);
  }


  /**
   * Consume los servicios que genera los JOBS
   */
  private consumeServiceJobs(data, handler: HandlerPromise) {

    let promises = [];

    data.forEach(element => {
      let auth = 'Basic ' + btoa(`${element.user}:${element.password}`)
      promises.push(this.generatePromise(element.url, element.payload, element.method, auth));
    });

    Promise.all(promises).then(
      (data_resp) => {

        let ind_err = false;
        data_resp.forEach(element => {
          if (element.estado != 'OK') ind_err = true;
        });

        if(ind_err){
          handler.error('Error al generar los JOBS')
          return;}

        handler.success(data_resp);
      },
      (error) => {
        handler.error(error);
      }
    );

  }

  /**
   * Genera las promesas con las peticiones.
   * @param url url de resuso a consumir.
   * @param payLoad data a enviar a la peticion.
   * @param method metodo de la peticion.
   */
  private generatePromise(url: string, payLoad, method: string, auth: string) {
    return new Promise((resolve, reject) => {
      let handler : HttpRequestHandler = {
        
        success: (resp: any) => {
          resolve(resp);
        },
        error: (e) => {
          reject(e);
        }, 
        headers : {'Authorization' : auth }
      };

      if(method.toUpperCase() == 'POST'){
        this._httpService.post(url, payLoad, handler);
      }else if (method.toUpperCase() == 'GET'){
        this._httpService.get(url,handler);
      }else if (method.toUpperCase() == 'PUT'){
        this._httpService.put(url, payLoad, handler);
      }else if (method.toUpperCase() == 'DELETE'){
        this._httpService.delete(url, handler)
      } 

    });
  }


  /**
   * Inicia el procesos de generacion de JOBS segun la parametrizacion del tercero
   * @param data data para consultar y generar los JOBS del tercero.
   */
  generateJobs(data, handler: HandlerPromise) {
    this.getPayLoads(data, {
      success: (resp: any) => {

        if (resp.data.status == 1) {
          this._alertService.openSwal({
            type: 'error',
            text: resp.data.message
          });
        } else {
          this.consumeServiceJobs(resp.data.jobs_params, handler);
        }

      },
      error: (err: any) => {

        let msg = 'Ocurrió un error al tratar de recuperar la parametrización de los JOBS.'
        console.error(err);
        this._alertService.openSwal({
          type: 'error',
          text: msg
        });
      }

    });
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/accounting/automatic-data-generation/generation-jobs.service.ts